import {routes as generic} from "./generic.routes";
import {routes as survey} from "./survey.routes";
import {routes as endpoint} from "./endpoint.routes";
import {routes as user} from "./user.routes";

    let allRoutes = [];
    allRoutes.push(...endpoint);
    allRoutes.push(...survey);
    allRoutes.push(...user);
    allRoutes.push(...generic);

export const routes = allRoutes;